import React from 'react';
import send from '@/public/svg/send.svg';

interface ModalProps {
    show: boolean;
    onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ show, onClose }) => {
    if (!show) return null;

    const handleClose = () => {
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg text-center relative">
                <h2 className="text-2xl font-bold mb-4">Gesendet!</h2>

                <p className="text-lg font-medium mb-4">
                    Anfrage erfolgreich gesendet!
                </p>

                <img
                    src={send}
                    alt="Send Icon"
                    loading="lazy"
                    className="mx-auto mb-4 max-h-64 object-contain"
                />

                <button
                    onClick={handleClose}
                    className="bg-secondary text-white px-6 py-2 rounded-full font-semibold hover:bg-secondaryDark transition"
                >
                    Schließen
                </button>
            </div>
        </div>
    );
};

export default Modal;
